import React, { useState } from "react"
import { useRequestCarrotCard } from "../request-carrot-card"
import { Form, FormCheckbox } from "@carrotfertility/carotene-core-x"
import { AirwallexUserAgreementTemplate, IssuingRegion } from "../agreement-helpers"
import { useAirwallexCardRequestSubmit } from "../../CardholderNameReview/use-name-on-card"
import { FormattedMessage } from "react-intl"
import { Link } from "@carrotfertility/carotene-core"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { HttpErrors } from "#/utils/HttpErrors"

export function AirwallexUnitedStatesUserAgreement() {
  const { send } = useStateMachine()
  const [isAddressError, setIsAddressError] = useState(false)
  const requestCardMutation = useRequestCarrotCard({
    onSuccess: () => send(""),
    onError: (error) => {
      if (error.name === HttpErrors.BAD_REQUEST && error.message.includes("postal_address")) {
        setIsAddressError(true)
      } else {
        setIsAddressError(false)
      }
    }
  })
  const submitCardRequest = useAirwallexCardRequestSubmit(requestCardMutation.mutateAsync)

  return (
    <Form onSubmit={submitCardRequest} defaultValues={{ airwallexUserAgreement: false }}>
      <AirwallexUserAgreementTemplate
        data-testid={`issuing-region-${IssuingRegion.US}`}
        disableContinue={["airwallexUserAgreement"]}
        userAgreementChecks={[
          <FormCheckbox
            name={"airwallexUserAgreement"}
            key="airwallex-user-agreement"
            label={
              <FormattedMessage
                values={{
                  airwallexTermsLink: (linkContent) => (
                    <Link href="https://www.airwallex.com/us/terms/carrot-scale" target="_blank" color="inherit">
                      {linkContent}
                    </Link>
                  ),
                  cardholderTermsLink: (linkContent) => (
                    <Link
                      href="https://www.airwallex.com/us/terms/cardholder-commercial#cardholder-terms"
                      target="_blank"
                      color="inherit"
                    >
                      {linkContent}
                    </Link>
                  )
                }}
                defaultMessage="I acknowledge I have received, reviewed, and agree to the Carrot Terms of Service, the <airwallexTermsLink>Airwallex terms</airwallexTermsLink> and the <cardholderTermsLink>Cardholder terms (Commercial)</cardholderTermsLink>."
              />
            }
            required
          />
        ]}
        isError={requestCardMutation.isError}
        isAddressError={isAddressError}
      />
    </Form>
  )
}
